
import { defineComponent, PropType } from 'vue'

import AuthProviderButton from '~/components/Auth/AuthProviderButton.vue'
import type { LoginOption } from '~/mixins/authMixin'
import { VcsProviderChoices } from '~/types/types'

type AuthProviderOption = LoginOption

const providerLabelMap: Partial<Record<VcsProviderChoices, string>> = {
  [VcsProviderChoices.Github]: 'GitHub',
  [VcsProviderChoices.GithubEnterprise]: 'GitHub Enterprise',
  [VcsProviderChoices.Gitlab]: 'GitLab',
  [VcsProviderChoices.Bitbucket]: 'Bitbucket',
  [VcsProviderChoices.BitbucketDatacenter]: 'Bitbucket',
  [VcsProviderChoices.Ads]: 'Azure DevOps Services'
}

export default defineComponent({
  name: 'AuthProviderButtons',
  components: {
    AuthProviderButton
  },
  props: {
    options: {
      type: Array as PropType<AuthProviderOption[]>,
      default: () => []
    },
    fullWidth: {
      type: Boolean,
      default: true
    },
    iconSize: {
      type: String,
      default: 'base'
    },
    stackClass: {
      type: String,
      default: 'flex flex-col items-center space-y-6'
    },
    getHref: {
      type: Function as PropType<(option: AuthProviderOption) => string | undefined>,
      default: undefined
    }
  },
  methods: {
    providerLabelFor(option: AuthProviderOption): string {
      return providerLabelMap[option.provider as VcsProviderChoices] || option.label
    },
    fullLabelFor(option: AuthProviderOption): string {
      const providerLabel = this.providerLabelFor(option)
      const isCustomLabel = option.label && option.label !== providerLabel

      return isCustomLabel ? option.label : `Continue with ${providerLabel}`
    },
    mobileLabelFor(option: AuthProviderOption): string {
      return option.mobileLabel || this.providerLabelFor(option)
    },
    resolvedHref(option: AuthProviderOption): string | undefined {
      if (this.getHref) {
        return this.getHref(option)
      }
      return option.link
    },
    handleSelect(option: AuthProviderOption, event: Event): void {
      this.$emit('select', option, event)
    }
  }
})
